export default __webpack_public_path__ + "img/it.69cedac1.svg";